module.exports = __webpack_public_path__ + "static/media/chatbot.c0af0513.svg";